module.exports = __webpack_public_path__ + "static/menu-beverage-8c92c1fa896ca151a13dc6c3a29e8e6a.jpg";